import { CareGapAlgorithm } from 'primary-schema';
import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowConsumerOfConditionsSchema, FlowConsumerOfDocumentExtractSchema, FlowConsumerOfLabValuesSchema, FlowConsumerOfMedicationsSchema, FlowConsumerOfSurgicalHistoriesSchema, } from '../consumer.js';
import { FlowBlockType } from '../type.js';
export const FlowCareGapAlgorithmBlockConfigSchema = z.object({
    algorithm: z.enum(CareGapAlgorithm, { message: 'Algorithm is required' }),
    payload: z.object({
        documents: FlowConsumerOfDocumentExtractSchema,
        labValues: FlowConsumerOfLabValuesSchema,
        medications: FlowConsumerOfMedicationsSchema,
        problems: FlowConsumerOfConditionsSchema,
        procedures: FlowConsumerOfSurgicalHistoriesSchema,
    }),
});
export const FlowCareGapAlgorithmBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.CareGapAlgorithmBlock),
    config: FlowCareGapAlgorithmBlockConfigSchema,
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.PatientFindings),
});
//# sourceMappingURL=config.js.map